//
//
//
//
//
//
//
//
//
//

export default {
  setup() {
    const date = new Date().toISOString().substr(0, 7)

    return {
      date,
    }
  },
}
